import {Routes} from "@angular/router";
import {WorkflowEndcustomerOneUpgradeCuComponent} from "./workflow-endcustomer-one-upgrade-cu.component";

export const workflowEndcustomerOneUpgradeCuRouting: Routes = [
    { path: 'upgrade-cu/:aid', component: WorkflowEndcustomerOneUpgradeCuComponent, children: [
            { path: 'address', component: WorkflowEndcustomerOneUpgradeCuComponent },
            { path: 'payment', component: WorkflowEndcustomerOneUpgradeCuComponent },
            { path: 'checkout', component: WorkflowEndcustomerOneUpgradeCuComponent },
            { path: 'complete', component: WorkflowEndcustomerOneUpgradeCuComponent },
            { path: '', redirectTo: 'address', pathMatch: 'full' },
    ]},
]
